import axios, { AxiosResponse } from "axios";
import { ApiErrorHandler } from "../../../../errorHandler";
import { ErroObj } from "../../../shared/interfaces/model/errorObj.interface";
import apiClient from "../../shared/api/apiClient";

// ------------------------PRODUCT-----------------------------------------

export const getProductList = (id?: string) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/product?last=&sortType=desc`;
  return apiClient
    .get(URL)
    .then(
      (response: AxiosResponse) => response.data
    )
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};
